import {Dispatch, SetStateAction} from 'react'
import {TTabs} from '../leadTypes'

export const NavMainEditLead: React.FC<{
  setFormType: Dispatch<SetStateAction<TTabs>>
  formType: TTabs
}> = ({setFormType, formType}) => {
  const tabs = [
    {title: 'Main', num: 1},
    {title: 'Notes', num: 2},
    {title: 'Appointments', num: 3},
    {title: 'Files', num: 4},
    {title: 'Consent', num: 5},
    {title: 'Activity', num: 6},
  ] as const

  return (
    <>
      <div className='policy-form-tabs'>
        {tabs.map((nav) => {
          const isActive =
            (formType === 'EDIT' && nav.title === 'Main') || nav.title === formType
          return (
            <div
              key={nav.title}
              className={isActive ? 'tab active' : 'tab'}
              style={{flex: 1}}
              onClick={() => setFormType(nav.title)}
            >
              <button className='btn btn-tabs' disabled={isActive}>
                <span className='policy-form-tabs-number'>{nav.num}</span>
                <span style={{color: isActive ? '#5d78ff' : 'gray'}}>{nav.title}</span>
              </button>
            </div>
          )
        })}
      </div>
      <hr className='my-4' style={{color: '#71839b'}} />
    </>
  )
}
